import { Component, Input, OnInit, inject } from "@angular/core";
import { SubDivision } from "@app/models/rest/roster/sub-division";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { RosterAssignmentStore } from "@app/services/store/roster/roster-assignment-store";
import { AddAssignmentDialogComponent } from "@app/view/setup/resourcing/roster/add-assignment-dialog/add-assignment-dialog.component";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { RosterAssignment } from "@app/models/rest/roster/roster-assignment";
import { MatToolbar } from "@angular/material/toolbar";
import { MatIconButton, MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { GridComponent } from "../../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-assignment-grid",
  templateUrl: "./assignment-grid.component.html",
  styleUrls: ["./assignment-grid.component.css"],
  imports: [
    MatToolbar,
    MatIconButton,
    MatIcon,
    MatButton,
    GridComponent,
    MatPaginator,
    TranslatePipe
  ]
})
export class AssignmentGridComponent
  extends BaseDataTablePageDirective<RosterAssignment>
  implements OnInit
{
  rosterAssignmentStore: RosterAssignmentStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  @Input()
  public subDivision: SubDivision;
  @Input()
  public columns: object[] = [
    {
      width: 60,
      type: "template",
      field: "resource.name",
      text: "Resource",
      flex: 1,
      sortable: true,
      template: ({ record }) => `<dl style="margin:0">
                <dt><img src="${record.resource.imageUrl}" height="40" width="40" style="border-radius:100%;box-shadow:1px 0px 5px #aaa"/></dt>
                </dl>${record.resource.name}`,
      editor: false
    },
    {
      field: "startDate",
      text: "Start",
      flex: 1,
      format: "DD/MM/YYYY",
      type: "date",
      editor: true
    },
    {
      field: "endDate",
      text: "End",
      flex: 1,
      format: "DD/MM/YYYY",
      type: "date",
      editor: true
    },
    {
      field: "lastRunDate",
      text: "Last Run Date",
      flex: 1,
      format: "DD/MM/YYYY",
      type: "date",
      editor: true
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const rosterAssignmentStore = inject(RosterAssignmentStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      rosterAssignmentStore,
      store,
      dialog,
      "RosterAssignment",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.rosterAssignmentStore = rosterAssignmentStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    super.ngOnInit();
    if (!this.subDivision) {
      return;
    }
    this.gridStore.parentField = "subDivision.id";
    this.gridStore.parentId = this.subDivision.id;
    this.gridStore.parentResource = this.subDivision;
    this.gridStore.parentRel = "subDivision";
    this.gridStore.autoCommit = false;
    this.gridStore.load({});
  }

  addRow() {
    this.gridStore.insert(0, {
      code: "",
      description: "",
      scoreWeight: 1
    });
  }

  openNewAssignmentDialog() {
    let dialogRef = this.dialog.open(AddAssignmentDialogComponent, {
      data: {
        subDivision: this.subDivision
      }
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        this.gridStore.load({});
      }
    });
  }
}
